import { forwardRef, memo, type SVGProps } from 'react';

export type MinimapIconProps = Omit<SVGProps<SVGSVGElement>, 'css'>;

/** Local navigator glyph until the Air icon package provides a dedicated minimap icon. */
export const MinimapIcon = memo(
  forwardRef<SVGSVGElement, MinimapIconProps>((props, ref) => (
    <svg
      ref={ref}
      {...props}
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <rect height="14" rx="2" width="14" x="5" y="5" />
      <rect fill="currentColor" height="5" rx="0.5" stroke="none" width="5" x="9.5" y="9.5" />
    </svg>
  )),
);

MinimapIcon.displayName = 'MinimapIcon';
